import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackbarService, ThemeMode, ThemeModeService } from '@fleet-beat/core';
import { BehaviorSubject } from 'rxjs';
import { NotifyConfig } from '../../models/notify-config.model';

@Component({
  selector: 'fb-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotifyComponent {
  messagesSubject: BehaviorSubject<NotifyConfig[]> = new BehaviorSubject([]);
  currentThemeSubject: BehaviorSubject<ThemeMode>;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private snackBarService: SnackbarService,
    private themeModeSerivce: ThemeModeService,
  ) {
    this.matIconRegistry.addSvgIcon(
      'error_hint',
      this.domSanitizer.bypassSecurityTrustResourceUrl('libs/core/src/lib/modules/snackbar/assets/error_hint.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'warning_hint',
      this.domSanitizer.bypassSecurityTrustResourceUrl('libs/core/src/lib/modules/snackbar/assets/warning_hint.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'success_hint',
      this.domSanitizer.bypassSecurityTrustResourceUrl('libs/core/src/lib/modules/snackbar/assets/success_hint.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'simple_hint',
      this.domSanitizer.bypassSecurityTrustResourceUrl('libs/core/src/lib/modules/snackbar/assets/simple_hint.svg'),
    );

    this.currentThemeSubject = this.themeModeSerivce.themeModeSubject;
    this.messagesSubject = this.snackBarService.notificationsSubject;
  }

  onClose(index: number): void {
    this.snackBarService.onClose(index);
  }

  onAction(item: NotifyConfig): void {
    this.snackBarService.onAction(item);
  }
}
